import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import cn from "classnames";

import FormikTextField from "components/InputsField/formikInputs/FormikTextField";
import PopupTitle from "components/common/PopupTitle";
import Button from "components/common/Button";
import Error from "components/Forms/Error";
import { validation } from "./validate";
import { signIn, removeErrors } from "store/auth";
import { getLoginReferrer, clearLoginReferrer } from "utils/loginReferrer";

import styles from "./styles.module.scss";
import { ERROR_PLACE } from 'components/InputsField/InputError';

const reServerError = /^5/;
const INITIAL_VALUES = {
    email: "",
    password: "",
};

const LoginForm = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const error = useSelector((state) => state.auth.error);
    const authenticated = useSelector((state) => state.auth.authenticated);

    const [passVisible, setPassVisible] = useState(false);

    const handleSubmit = (values) => {
        dispatch(signIn(values));
    };

    const handlePassVisible = () => {
        setPassVisible(!passVisible);
    };

    useEffect(() => {
        if (authenticated) {
            const referrer = getLoginReferrer();
            clearLoginReferrer();
            navigate(referrer);
        }
    }, [authenticated, navigate]);

    useEffect(() => {
        return () => {
            dispatch(removeErrors());
        };
    }, [dispatch]);

    return (
        <div>
            <PopupTitle title={t("login.heading")} withLogo />
            <Formik
                initialValues={INITIAL_VALUES}
                validationSchema={validation(t)}
                onSubmit={handleSubmit}
            >
                <Form>
                    <FormikTextField
                        name="email"
                        maxLength="64"
                        label={t("login.email")}
                        type="email"
                        wrapperClassName={styles.loginField}
                        errorMode={ERROR_PLACE.static}
                        required
                        autoComplete="username"
                    />
                    <FormikTextField
                        name="password"
                        type={passVisible ? "text" : "password"}
                        maxLength="64"
                        label={t("login.password")}
                        errorMode={ERROR_PLACE.static}
                        autoComplete="current-password"
                        additionalComponent={
                            <button
                                className={cn(styles.eye, passVisible && styles["eye--hide"])}
                                onClick={handlePassVisible}
                                type="button"
                            />
                        }
                        required
                    />
                    <div className={styles.button}>
                        <Button type="submit">{t("login.login_button")}</Button>
                    </div>
                </Form>
            </Formik>
            {error && (
                <div className={styles.error}>
                    <Error>
                        {reServerError.test(error.status)
                            ? t("login.serverError")
                            : t("login.wrong")}
                    </Error>
                </div>
            )}
        </div>
    );
};

export default LoginForm;
